import(/* webpackMode: "eager" */ "/app/app/[locale]/(dynamic)/portal/layout.tsx");
